import { tw } from '@tw';

/**
 * THE height of anything that stands on its own in the bar — the capsule, a
 * pill beside it, the burger. It is not a taste: a segment is `h-10` and the
 * capsule pads it by 6px a side, so 40 + 12 is what a free-standing control
 * must be to line up with one. The bar carried three heights until 2026-08-21;
 * anything new wears this.
 */
export const BAR_H = 'h-13';

/**
 * The rail capsule: the bar's surface and shadow, holding segments that carry
 * only their own state. Lives here so the capsule and the pills that stand
 * beside it are sized by the same file — that is what keeps them level.
 */
export const BAR_CAPSULE = tw(
  BAR_H,
  'pointer-events-auto flex items-center gap-0.5 rounded-full bg-[var(--bar-raise)] p-1.5 shadow-[shadow:var(--bar-shadow)]'
);

/**
 * A segment inside a bar capsule: the capsule carries the bar surface and
 * shadow, a segment carries only its state — `--bar-mine` when it is the one
 * thing to press, quiet text with the sheet's `--bar-sel` hover otherwise.
 * Only the shortcut and Sign in take the fill; the menu rows are all quiet,
 * including the section you are standing in. Lives here so "the bar's
 * material" has exactly one file.
 */
export function segmentPill(active: boolean): string {
  return tw(
    'mm-btn flex h-10 items-center rounded-full px-4 text-p-3 font-bold whitespace-nowrap',
    active
      ? 'bg-[var(--bar-mine)] text-[var(--bar-mine-fg)] hover:brightness-95'
      : 'text-[var(--bar-fg)] hover:bg-[var(--bar-sel)]'
  );
}
